import { en } from "./translations.en";
import { fr } from "./translations.fr";
import { pt } from "./translations.pt";

export const translations = {
  en: {
    changePassword: en,
  },
  fr: {
    changePassword: fr,
  },
  pt: {
    changePassword: pt,
  },
};
